import { render, staticRenderFns } from "./discover_modal_photo_bgimage.vue?vue&type=template&id=26024d2c&"
import script from "./discover_modal_photo_bgimage.vue?vue&type=script&lang=js&"
export * from "./discover_modal_photo_bgimage.vue?vue&type=script&lang=js&"
import style0 from "./discover_modal_photo_bgimage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports